(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/self-exclusion-react/assets/react/components/vertical.js') >= 0) return;  svs.modules.push('/modules/self-exclusion-react/assets/react/components/vertical.js');
'use strict';

const {
  useCallback
} = React;
const {
  Games,
  Periods
} = svs.selfExclusion.components;
const {
  useAtom
} = jotai;
const {
  gameAtom,
  periodAtom,
  activeExclusionsAtom,
  submitAtom
} = svs.selfExclusion.atoms.selfExclusionAtoms;
const Vertical = () => {
  const [game, setGame] = useAtom(gameAtom);
  const [, setPeriod] = useAtom(periodAtom);
  const [activeExclusions] = useAtom(activeExclusionsAtom);
  const exclusionDates = svs.selfExclusion.useExpiryDate(activeExclusions, game);
  const [isSubmitted] = useAtom(submitAtom);
  const handleGame = useCallback(gameValue => {
    setGame(gameValue);
    setPeriod();
  }, [setGame, setPeriod]);
  const handlePeriod = useCallback(periodValue => {
    setPeriod(periodValue);
  }, [setPeriod]);
  return React.createElement("div", {
    className: "exclusion-pause-wrapper padding-xs-bottom-2"
  }, React.createElement(Games, {
    key: isSubmitted,
    onHandleGame: handleGame,
    selectedGame: game
  }), React.createElement(Periods, {
    activeExclusions: activeExclusions,
    exclusionDates: exclusionDates,
    game: game,
    key: game,
    onHandlePeriod: handlePeriod
  }));
};
svs.selfExclusion.components.Vertical = Vertical;

 })(window);